import type { IClinic } from '@dataTypes/clinic.type'
import type { VariableData } from '@dataTypes/message.types'

/**
 * Placeholder keys used when inserting variables in notes.
 * Same keys are used for substitution in view mode with real values.
 */
export const NOTE_VARIABLE_KEYS = [
  '(patient_name)',
  '(clinic_name)',
  '(practice_number)',
  '(practice_services)',
] as const

export type NoteVariableKey = (typeof NOTE_VARIABLE_KEYS)[number]

export interface NoteVariableContext {
  clinic?: IClinic | null
  patientName?: string
}

/**
 * Builds the variable list for the Note Editor with current context values.
 * Used for "Insert variable" options and for substituting placeholders in view mode.
 */
export function buildNoteVariableList(
  context: NoteVariableContext,
): VariableData[] {
  const { clinic, patientName = '' } = context
  return [
    { text: '(patient_name)', value: patientName },
    { text: '(clinic_name)', value: clinic?.clinic_name ?? '' },
    { text: '(practice_number)', value: clinic?.phone_number ?? '' },
    {
      text: '(practice_services)',
      value: '', // Optional: add clinic services field when available
    },
  ]
}
